import type { DtsOutboundSftpDto } from '@dhl/mdp-api'
import { DataRow, DataHeading } from '~/modules/ppp/submodules/relations/components/data'
import { presentDateOrDefault } from '~/modules/ppp/submodules/relations/utils'

type Props = {
  config: DtsOutboundSftpDto
}
export const OutboundSftp = ({ config }: Props) => (
  <>
    <DataHeading title="SFTP" />
    <DataRow title="createdOn" payload={presentDateOrDefault(config.sftpServer.createdOn)} />
    <DataRow title="host" payload={config.sftpServer.host} withCopy />
    <DataRow title="portNumber" payload={config.sftpServer.portNumber} withCopy />
    <DataRow title="serverName" payload={config.sftpServer.serverName} withCopy />
    <DataRow title="userAuthType" payload={config.sftpServer.userAuthType} />
    <DataRow title="username" payload={config.sftpServer.username} withCopy />
    <DataRow title="path" payload={config.sftpOutSettings.path} withCopy />
    <DataRow title="backupDirectory" payload={config.sftpOutSettings.backupDirectory} withCopy />
    <DataRow title="filenamePattern" payload={config.sftpOutSettings.filenamePattern} withCopy />
    <DataRow title="temporaryDirectory" payload={config.sftpOutSettings.temporaryDirectory} withCopy />
    <DataRow title="temporaryPrefix" payload={config.sftpOutSettings.temporaryPrefix} withCopy />
  </>
)
